<script setup lang="ts">
import type { CmsElementPluebelCmsElementsHeadlineTextBoxenSliderNumbers } from "~/composables/useCustom";
import { useCmsElementConfig } from "#imports";

const props = defineProps<{
  content: CmsElementPluebelCmsElementsHeadlineTextBoxenSliderNumbers;
}>();

const { getConfigValue } = useCmsElementConfig(props.content);

const makeoverBoxes = computed(() => getConfigValue("makeover_box"));
const headline = computed(() => getConfigValue("headline"));
const text = computed(() => getConfigValue("text"));
const slider = useTemplateRef("slider");

const config: ComputedRef<SliderElementConfig> = computed(() => ({
  displayMode: {
    value: "cover",
    source: "static",
  },
  navigationDots: {
    value: "",
    source: "static",
  },
}));

const windowWidth = ref(
  typeof window !== "undefined" ? window.innerWidth : 1024
);

onMounted(() => {
  const updateWidth = () => (windowWidth.value = window.innerWidth);
  window.addEventListener("resize", updateWidth);
  onUnmounted(() => window.removeEventListener("resize", updateWidth));
});

const makeoverBoxesSlider = ref(null);

const makeoverBoxesSwiperSlider = useSwiper(makeoverBoxesSlider, {
  effect: "slide",
  loop: true,
  grabCursor: true,
  slidesPerView: 3,
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
});
</script>
<template>
  <section class="pb-20 md:pb-28 lg:pb-40 xl:pb-52">
    <div class="container">
      <div class="max-w-[1110px] w-full m-auto overflow-hidden">
        <div class="flex items-end justify-between">
          <div class="pe-10">
            <h3 v-if="headline" class="mb-2">{{ headline }}</h3>
            <p v-if="text">
              {{ text }}
            </p>
          </div>
          <div class="flex gap-x-4 text-2xl">
            <button @click="makeoverBoxesSwiperSlider.prev()">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button @click="makeoverBoxesSwiperSlider.next()">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
        <div
          class="pt-10 cat-slider-03 sliderArrow sm:-ms-2 md:-ms-4 lg:-ms-8 relative"
        >
          <div
            v-if="makeoverBoxes.length"
            @click="makeoverBoxesSwiperSlider.prev()"
            class="swiper-cust-button-prev bg-cust_cream text-cust_gray03"
          >
            <i class="fa-solid fa-arrow-left"></i>
          </div>
          <swiper-container ref="makeoverBoxesSlider">
            <swiper-slide v-for="(box, i) in makeoverBoxes" :key="i">
              <div class="sm:ps-2 md:ps-4 lg:ps-8">
                <div class="">
                  <figure
                    v-if="box.makeover_image"
                    class="mb-8 img-cover aspect-4/3 rounded-3xl overflow-hidden"
                  >
                    <NuxtImg
                      format="webp"
                      loading="lazy"
                      :width="box.makeover_image?.metaData?.width"
                      :height="box.makeover_image?.metaData?.height"
                      :src="box.makeover_image?.url"
                      :alt="box.makeoverheadline"
                    />
                  </figure>
                  <div>
                    <h4 class="mb-4 flex items-center gap-4">
                      <NuxtImg
                        loading="lazy"
                        format="webp"
                        :src="box.makeover_number?.url"
                        :width="box.makeover_number?.metaData?.width"
                        :height="box.makeover_number?.metaData?.height"
                        :alt="
                          box.makeover_number?.alt ||
                          box.makeover_number?.fileName ||
                          box.makeoverheadline
                        "
                      />
                      {{ box.makeoverheadline }}
                    </h4>
                    <p v-if="box.makeover_text">
                      {{ box.makeover_text }}
                    </p>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper-container>
          <div
            v-if="makeoverBoxes.length"
            @click="makeoverBoxesSwiperSlider.next()"
            class="swiper-cust-button-next bg-cust_cream text-cust_gray03"
          >
            <i class="fa-solid fa-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
